import $ from 'jquery';
import flatMap from 'lodash/flatMap';
import forOwn from 'lodash/forOwn';
import isEmpty from 'lodash/isEmpty';
import uniqWith from 'lodash/uniqWith';
import makeMoment from '../common/moment/MomentFactory';
import EventService from '../common/event/EventService';
import PortalEvent from './events/PortalEvent';
import UpdateReceivedEvent from './events/UpdateReceivedEvent';
import UpdateServiceEvent from './events/UpdateServiceEvent';
import AlertService from '../common/alert/AlertService';
import VcomProvider from '../VcomProvider';

export default function UpdateService() {
  const services = [];
  const updateInterval = 60000 * 5;
  let lastCurrentDate;
  let timeout = -1;
  let updateRunning = false;

  function getElementsToUpdate(subscribers) {
    const elementsToUpdate = flatMap(subscribers, (subscriber) => subscriber.getElementsToUpdate());
    return uniqWith(elementsToUpdate, (a, b) => a.id === b.id && a.type === b.type);
  }

  function checkForUpdates() {
    if (timeout > -1) {
      clearTimeout(timeout);
    }
    if (updateRunning) {
      timeout = setTimeout(checkForUpdates, updateInterval);
      return;
    }
    updateRunning = true;
    const activeServices = [];
    const currentDate = makeMoment();

    const hasMonthPassed = currentDate.month() !== lastCurrentDate.month();
    if (hasMonthPassed) {
      EventService.dispatch(PortalEvent.CURRENT_MONTH_PASSED);
    }

    const hasDayPassed = () => {
      const startOfLastCurrentDate = lastCurrentDate.clone().startOf('day');
      return currentDate.diff(startOfLastCurrentDate, 'days') >= 1;
    };

    if (hasDayPassed()) {
      lastCurrentDate = currentDate;
      EventService.dispatch(PortalEvent.CURRENT_DAY_PASSED);
    }

    forOwn(services, (value, key) => {
      let elementsToUpdate;
      if (key === 'currentSystemData' && VcomProvider.anlage) {
        elementsToUpdate = getElementsToUpdate(value);
        if (!isEmpty(elementsToUpdate)) {
          activeServices.push({
            service: key,
            serviceData: {
              date: VcomProvider.anlage.getDate(),
              elements: elementsToUpdate,
            },
          });
        }
      } else if (key === 'currentSchemagraphData') {
        elementsToUpdate = getElementsToUpdate(value);
        activeServices.push({
          service: key,
          serviceData: {
            elements: elementsToUpdate,
            systemId: VcomProvider.anlage.getAnlagenId(),
          },
        });
      } else if (key === 'anlageueberwachungen') {
        const iIdAnlage = getElementsToUpdate(value);
        activeServices.push({
          service: key,
          serviceData: {
            systemId: iIdAnlage,
          },
        });
      } else {
        activeServices.push({
          service: key,
        });
      }
    });

    EventService.dispatch(PortalEvent.UPDATE_REQUESTED);
    $.ajax({
      type: 'POST',
      url: `${VcomProvider.baseUrl}/default/index/jsgateway/`,
      data: {
        activeServices,
      },
      success(data) {
        if (!data.error) {
          $.each(data, (index, value) => {
            if (value) {
              EventService.dispatch(`${index}${UpdateReceivedEvent.GENERIC}`, { data: value });
            }
          });
        } else if (data.message) {
          AlertService.showError(data.message);
        }
      },
      complete() {
        EventService.dispatch(UpdateServiceEvent.RECEIVED);
        if (localStorage.getItem('autoRefreshActivated') === 'true') {
          timeout = setTimeout(checkForUpdates, updateInterval);
        }
        updateRunning = false;
      },
      dataType: 'json',
    });
  }

  function isActiveService(service) {
    return Object.prototype.hasOwnProperty.call(services, service);
  }

  function hasSubscribed(subscriber, service) {
    return $.inArray(subscriber, services[service]) >= 0;
  }

  function setAutoRefreshHtmlActive() {
    $('#auto-refresh-icon').toggleClass('icon-toggle-off icon-toggle-on');
  }

  function setAutoRefreshHtmlPaused() {
    $('#auto-refresh-icon').toggleClass('icon-toggle-on icon-toggle-off');
  }

  function updateAutoRefresh() {
    if (localStorage.getItem('autoRefreshActivated') === 'true') {
      setAutoRefreshHtmlPaused();
      localStorage.setItem('autoRefreshActivated', 'false');
      clearTimeout(timeout);
    } else {
      setAutoRefreshHtmlActive();
      localStorage.setItem('autoRefreshActivated', 'true');
      timeout = setTimeout(checkForUpdates, updateInterval);
    }
  }

  function init() {
    lastCurrentDate = makeMoment();
    if (timeout > -1) {
      clearTimeout(timeout);
    }
    $('#auto-refresh-control').on('click', updateAutoRefresh);
    if (localStorage.getItem('autoRefreshActivated') === 'false') {
      setAutoRefreshHtmlPaused();
    } else {
      localStorage.setItem('autoRefreshActivated', 'true');
      timeout = setTimeout(checkForUpdates, updateInterval);
    }
  }

  return {
    init,
    subscribe(subscriber, service) {
      if (typeof subscriber === 'undefined') {
        return;
      }
      if (!isActiveService(service)) {
        services[service] = [];
      }
      if (!hasSubscribed(subscriber, service)) {
        services[service].push(subscriber);
      }
    },
    update: checkForUpdates,
  };
}
